import Section from '../Section';

export default class Testimonails extends Section {

}
